module.exports = __webpack_public_path__ + "static/img/v7.66941af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v7.svg
// module id = NDJs
// module chunks = 0